// extracted by mini-css-extract-plugin
var _1 = "AvatarWithAction-module__avatarContainer--V56vv";
var _2 = "AvatarWithAction-module__comment--BEkmr";
var _3 = "AvatarWithAction-module__icon--j5QPK";
var _4 = "AvatarWithAction-module__iconContainer--jNAb8";
var _5 = "AvatarWithAction-module__muted--u6ViF";
var _6 = "AvatarWithAction-module__post--e3Cfi";
var _7 = "AvatarWithAction-module__success--cMSyG";
var _8 = "AvatarWithAction-module__warning--O_QxC";
export { _1 as "avatarContainer", _2 as "comment", _3 as "icon", _4 as "iconContainer", _5 as "muted", _6 as "post", _7 as "success", _8 as "warning" }
